import { ModalNotAllowedBuyFlowers } from '@lideralia/alife-uikit/dist/organisms/Modals/NotAllowedBuyFlowers';
import React from 'react';

export const NotAllowedBuyFlowersTemplate = (props) => <ModalNotAllowedBuyFlowers {...props} />;
